module.exports = __webpack_public_path__ + "static/img/icon_passcard_ticket.dee25569.png";